import { defaultFill } from '../utils/constants';
var muiCaretLeftGlyph = {
    paths: [
        {
            path: 'M12.7091115,5.20911154 L5.70911154,12.2091115 C5.31858724,12.5996358 4.68542227,12.5996358 4.29489797,12.2091115 L-2.70510203,5.20911154 C-3.33506689,4.57914667 -2.8889001,3.50200475 -1.99799525,3.50200475 L12.0020048,3.50200475 C12.8929096,3.50200475 13.3390764,4.57914667 12.7091115,5.20911154 Z',
            fill: defaultFill,
        },
    ],
    title: 'Caret Left',
    width: 10,
    height: 16,
    rotate: 90,
};
var muiCaretLeft = {
    base: muiCaretLeftGlyph,
};
export { muiCaretLeft };
//# sourceMappingURL=caretLeft.js.map